<script>
  import Menu from "../components/Menu.svelte";
  import Breadcrumbs from "../components/Breadcrumbs.svelte";
  import Footer from "../components/Footer.svelte";
  import ArticleListEditorItem from "../components/ArticleListEditorItem.svelte";

  import { dictionary } from "../utils/stores.js";
  import { getToken, redirectIfNotToken } from "../utils/token.js";
  import { post, SERVER_URL } from "../utils/api.js";

  import { onMount } from "svelte";

  redirectIfNotToken("/login");

  let dict;

  const unsubscribe = dictionary.subscribe((value) => {
    dict = value;
  });

  const pageName = "articulos";
  let filtro = "todos";

  let articulos = [];

  let chiefEditor = false;

  onMount(async () => {
    const response = await post("RolUsuario", { token: getToken() }, "json");
    chiefEditor = response.editorJefe;
    listarArticulos();
  });

  let listarArticulos = async () => {
    articulos = await post(
      "MisArticulosComoEditor",
      {
        token: getToken(),
      },
      "json"
    );
    articulos = articulos.reverse();
  };

  let openArticle = (id) => {
    location.href = "/articulo/" + id + "/";
  };

  let logArticle = (id) => {
    window.open("/historial-articulo/" + id + "/", "_blank");
  };
</script>

<div class="ie-panel">
  <a href="http://windows.microsoft.com/en-US/internet-explorer/">
    <img
      src="images/ie8-panel/warning_bar_0000_us.jpg"
      height="42"
      width="820"
      alt="You are using an outdated browser. For a faster, safer browsing
      experience, upgrade for free today."
    />
  </a>
</div>
<div class="preloader" id="loading">
  <div class="preloader-body">
    <div id="loading-center-object">
      <div class="object" id="object_four" />
      <div class="object" id="object_three" />
      <div class="object" id="object_two" />
      <div class="object" id="object_one" />
    </div>
  </div>
</div>
<div class="page">
  <!-- Menu -->

  <Menu {pageName} />

  <!-- Breadcrumbs -->

  <Breadcrumbs pageName={dict[pageName]} />

  <!-- Body -->

  <section class="section">
    <div class="container">
      <h3 class="titulo">
        {dict["misArticulosEditor"]}
        {#if chiefEditor}
          <a
            class="button button-sm button-primary-outline"
            target="_blank"
            href={SERVER_URL + "ExportarCSV.php?token=" + getToken()}
          >
            {dict["exportarTodo"]}
          </a>
        {/if}
      </h3>
      <div class="filtros">
        <span>{dict["filtrar"]}:</span>
        <select bind:value={filtro}>
          <option value="todos">{dict["todos"]}</option>
          <option value="enviado">{dict["enviados"]}</option>
          <option value="revision1">{dict["1revision"]}</option>
          <option value="revision2">{dict["2revision"]}</option>
          <option value="aceptado">{dict["aceptados"]}</option>
          <option value="rechazado">{dict["rechazados"]}</option>
        </select>
      </div>
      <div class="articulos">
        {#each articulos as articulo}
          {#if filtro === "todos" || (filtro === "enviado" && articulo.estado === "Enviado") || (filtro === "revision1" && articulo.estado === "Revision") || (filtro === "revision2" && articulo.estado === "Revision2") || (filtro === "aceptado" && articulo.estado === "Aceptado") || (filtro === "rechazado" && articulo.estado === "Rechazado")}
            <ArticleListEditorItem
              {articulo}
              onClickArticle={() => openArticle(articulo.id)}
              onClickLog={() => logArticle(articulo.id)}
            />
          {/if}
        {/each}
      </div>
    </div>
  </section>
  <Footer />
</div>
<div class="snackbars" id="form-output-global" />

<style>
  div.filtros {
    margin-top: 40px;
  }

  div.filtros span {
    margin-right: 10px;
  }

  div.articulos {
    margin-top: 40px;
    margin-bottom: 20px;
    width: 100%;
  }

  h3.titulo {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
</style>
